import { render } from "./AdministracionFacturaComponent.vue?vue&type=template&id=bd1f6b40&scoped=true"
import script from "./AdministracionFacturaComponent.vue?vue&type=script&lang=js"
export * from "./AdministracionFacturaComponent.vue?vue&type=script&lang=js"

import "./AdministracionFacturaComponent.vue?vue&type=style&index=0&id=bd1f6b40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1f6b40"]])

export default __exports__